import { createSelector } from 'reselect';
import { getCurrentAgentId } from '../Agents/selectors';
import {
  getSelectedForm,
  getLeadSource,
} from '../LeadAds/selectors';

export const getAdLength = state => state.campaign.adLength;
export const getAdBudget = state => state.campaign.budget;
export const getAdType = state => state.campaign.adType;
export const getAdName = state => state.campaign.name;
export const getSearchId = state => state.campaign.searchId;
export const getEndCardEnabled = state => state.campaign.endCardEnabled;
export const getSelectedInstagramId = state => state.campaign.instagramAccount;
export const getCurrentLink = state => state.campaign.link;
export const getLinkAnalyzed = state => state.campaign.linkAnalyzed;

export const getCampaignName = createSelector(
  getAdName,
  getCurrentAgentId,
  getLeadSource,
  getSearchId,
  getSelectedForm,
  (adName, agentId, source, searchId, selectedLeadAd) => {
    if (selectedLeadAd) {
      let string = `${adName} : ${source} : ${searchId}`;

      if (agentId != null) {
        string += ` : ${agentId}`;
      }

      return string;
    }

    return adName;
  },
);
